import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NotificationsService } from '../../../../services/notifications.service';
import { NotificationElement } from 'src/app/models/dashboard.shared';

@Component({
  selector: 'app-owner-notifications-list',
  templateUrl: './owner-notifications-list.component.html',
  styleUrls: ['./owner-notifications-list.component.css'],
})
export class OwnerNotificationsListComponent implements OnInit {
  @Output() NotificationElementClicked =
    new EventEmitter<NotificationElement>();
  // @Input() notifications: NotificationElement[] = [
  //   {
  //     id: 1,
  //     content: ', has accepted your invitation to join your network.',
  //     target: { label: 'Hossam Abdallah (hossam@gmail.com)' },
  //     type: OwnerNotificationTypeEnum.affiliate_accepted,
  //     status: NotificationStatusEnum.unread,
  //     image: 'https://picsum.photos/200',
  //     time: 1648358110,
  //   },
  // ];

  constructor(public notificationsService: NotificationsService) {}

  currentOffset = 0;
  limit = 10;
  ngOnInit(): void {
    this.currentOffset =
      this.notificationsService.ownerNotifications?.notifications?.length || 0;
  }

  loadMore() {
    this.currentOffset =
      this.notificationsService.ownerNotifications.notifications.length;
    // Pass undefined for filterType to let service use the current one
    this.notificationsService.loadMoreOwnerNotifications(
      this.currentOffset,
      this.limit
    );
  }
}
